import YSF from '@neysf/qiyu-web-sdk';

let ysf = null;

export const qiyuInit = (config) => {
    const setConfig = (resolve, reject) => {
        ysf('config', {
            ...config,
            success () {
                resolve();
            },
            error () {
                reject();
            },
        });
    };
    return new Promise((resolve, reject) => {
        if (!ysf) {
            YSF.init('5b13917a6a84ef7a95186847ffb19eb4', {
                // templateId: 123, // templateId表示自定义会话邀请的模板标识
                // shuntId: 123, // shuntId表示访客选择多入口分流模版id
                // sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
                hidden: 1, // hidden表示是否隐藏访客端默认入口
            }).then((y) => {
                ysf = y;
                setConfig(resolve, reject);
            });
        } else {
            setConfig(resolve, reject);
        }
    });
};

export const qiyuLogout = () => {
    if (ysf) {
        ysf('logoff');
    }
};
